import React, { useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import GridItem from '~/components/GridItem';
import GridContainer from '~/components/GridContainer';
import InputLabel from '@material-ui/core/InputLabel';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import isPresent from '~/utils/isPresent';

const Activities = ({ data = [], keys = [] }) => {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`activities.attributes.${attr}`);

    useEffect(() => {
    }, []);

    return (
        <GridContainer style={{ marginTop: 10 }}>
            <GridItem xs={12}>
                <InputLabel shrink>{t('activities.defPlural')}</InputLabel>
                {isPresent(keys) &&
                    <TableContainer style={{ maxHeight: 300 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow> {keys.map((key) => <TableCell key={key}>{trAttr(key)}</TableCell>)}</TableRow>
                            </TableHead>
                            <TableBody>
                            {isPresent(data) && data.map((row) => {
                                return (
                                    <TableRow hover tabIndex={-1} key={row.id}>
                                        {keys.map((key) => {
                                            return (
                                                <TableCell key={key}>
                                                    {key.includes('_at') ? moment(row[key]).format('DD/MM/YYYY HH:mm:ss') : String(row[key])}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                            {!isPresent(data) && <TableRow>
                                <TableCell align='center' colSpan={100}>
                                    {t('activities.extras.no_registers')}
                                </TableCell>
                            </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </GridItem>
        </GridContainer>
    );
};

export default React.memo(Activities);

